// extracted by css-extract-rspack-plugin
export default {"InsightsLink":"KiiFf"};